import {
  Button,
  Col,
  ConfigProvider,
  DatePicker,
  Divider,
  Form,
  Input,
  Modal,
  Pagination,
  Radio,
  Row,
  Select,
  Table,
  Tag,
} from 'antd'
import dayjs from 'dayjs'
import 'dayjs/locale/ko'
import React, { useEffect, useState } from 'react'
import DaumPostcodeEmbed from 'react-daum-postcode'
import { useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import * as XLSX from 'xlsx'
import orderApi from '../../api/order.api'
import pushApi from '../../api/push.api'
import OrderDetailComponent from '../../components/sales/OrderDetailComponent'
import ContentHeader from '../../components/shared/ContentHeader'
import { userState } from '../../store/user'
import { CustomDateButtonRadioTheme } from '../../styles/CustomAntdTheme'
import styles from '../../styles/sales.module.scss'
import statusUtil from '../../utils/status'

const numberReg = /^[0-9]*$/
dayjs.locale('ko')

const OrderDeliveryPage = () => {
  const navigate = useNavigate()
  const [user, setUser] = useRecoilState(userState)
  const [isLoading, setIsLoading] = useState(false)
  // const searchText = useSelector((state) => state.common.searchText);
  // const setIsSearchText = (value) => dispatch(setSearchText(value));
  // const recordDates = useSelector((state) => state.common.recordDates);
  // const setDates = (value) => dispatch(setRecordDates(value));

  const [orderDeliveryStatus, setOrderDeliveryStatus] = useState({
    deliveryShipping: 0,
    deliveryComplete: 0,
  })
  const [dateType, setDateType] = useState('1week')
  const [searchOptions, setSearchOptions] = useState({
    searchType: 'paymentCreatedAt',
    searchStatus: 'total',
    searchOrderId: '',
    searchProductName: '',
    funnel: 0,
    name: '',
    phone: '',
    startDate: dayjs().subtract(7, 'days').startOf('day'),
    endDate: dayjs().endOf('day'),
  })
  const [orderType, setOrderType] = useState('paymentCreatedAt')
  const [orderBy, setOrderBy] = useState('desc')
  const [selectedRowKey, setSelectedRowKey] = useState([])
  const [selectedRow, setSelectedRow] = useState([])
  const [currentPageNumber, setCurrentPageNumber] = useState(1)
  const [totalSize, setTotalSize] = useState(0)
  const [offset, setOffset] = useState(0)
  const [pageSize, setPageSize] = useState(10)
  const [deliveryCompanyList, setDeliveryCompanyList] = useState([])
  const [totalOrderList, setTotalOrderList] = useState([])
  const [orderList, setOrderList] = useState([])
  const [orderDetail, setOrderDetail] = useState({})
  const [editDeliveryInfo, setEditDeliveryInfo] = useState({})
  const [customerDeliveryInfo, setCustomerDeliveryInfo] = useState({})
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isPostalCodeModalOpen, setIsPostalCodeModalOpen] = useState(false)
  const [isDeliveryShippingModalOpen, setIsDeliveryShippingModalOpen] =
    useState(false)
  const [isOrderModalOpen, setIsOrderModalOpen] = useState(false)
  const [validation, setValidation] = useState(false)
  const [uploadExcelDataHeader, setUploadExcelDataHeader] = useState([])
  const [uploadExcelData, setUploadExcelData] = useState([])

  const searchDateItems = [
    { searchText: '결제일', searchType: 'paymentCreatedAt' },
    { searchText: '발송일', searchType: 'shipDate' },
    // {searchText: '배송일', searchType: 'delivery_complete_date'}
  ]
  const dateTypeItems = [
    { label: '오늘', value: 'today' },
    { label: '1주일', value: '1week' },
    { label: '1개월', value: '1month' },
    { label: '3개월', value: '3month' },
    { label: '6개월', value: '6month' },
  ]
  const orderStatusItems = [
    { label: '전체', value: 'total' },
    // {label: '입금대기', value: 'ready'},
    // {label: '입금완료', value: 'paid'},
    // {label: '결제실패', value: 'failed'},
    // {label: '결제취소', value: 'cancelled'},
    { label: '배송준비중', value: 'delivery_ready' },
    { label: '배송중', value: 'delivery_shipping' },
    { label: '배송완료', value: 'delivery_complete' },
    { label: '구매확정', value: 'complete' },
    // {label: '취소요청', value: 'cancel_request'},
    // {label: '교환요청', value: 'exchange_request'},
    // {label: '반품요청', value: 'return_request'},
    // {label: '취소완료', value: 'cancel_complete'},
    // {label: '교환완료', value: 'exchange_complete'},
    // {label: '반품완료', value: 'return_complete'}
  ]
  const funnelStatusItems = [
    { label: '전체', value: 0 },
    { label: '검색', value: 1 },
    { label: '전화주문', value: 4 },
    // { label: '인플루언서', value: 2 },
    // { label: '셀러', value: 5 },
    { label: '공동구매', value: 3 },
  ]
  const orderPair = {
    paymentCreatedAt: '결제일순',
    order_id: '주문번호순',
    // created_at: '주문일시순'
  }
  const rowSelection = {
    selectedRowKeys: selectedRowKey,
    onChange: (selectedRowKeys, selectedRows) => {
      for (const row of selectedRows) {
        if (
          !Object.prototype.hasOwnProperty.call(
            editDeliveryInfo,
            row.orderDetailId,
          )
        ) {
          editDeliveryInfo[row.orderDetailId] = {
            orderId: row.orderId,
            orderDetailId: row.orderDetailId,
            orderDetailStatus: 'delivery_shipping',
            deliveryCompany: row.deliveryCompany,
            trackingNumber: row.trackingNumber,
            shipDate:
              row.shipDate === null || row.shipDate === ''
                ? dayjs()
                : dayjs(row.shipDate),
          }
        }
      }
      let difference = Object.keys(editDeliveryInfo).filter(
        (orderDetailKey) => !selectedRowKeys.includes(parseInt(orderDetailKey)),
      )
      if (difference?.length !== 0) {
        for (const orderDetailKey of difference) {
          delete editDeliveryInfo[orderDetailKey]
        }
      }
      setSelectedRowKey(selectedRowKeys)
      setSelectedRow(selectedRows)
    },
  }
  const columns = [
    {
      title: '주문번호',
      width: 90,
      dataIndex: 'orderId',
      key: 'orderId',
      fixed: 'left',
      ellipsis: true,
      sorter: () => {},
      render: (value, record) => {
        return (
          <span
            className={`${styles['recommend-inquiry-list-title']}`}
            onClick={() => {
              setOrderDetail(record)
              setIsOrderModalOpen(true)
            }}
          >
            {value}
          </span>
        )
      },
    },
    {
      title: '주문일시',
      // width: 160,
      dataIndex: 'createdAt',
      key: 'createdAt',
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value !== null) {
          const date = dayjs(value).format('YYYY.MM.DD. HH:mm')
          return date
        }
      },
    },
    {
      title: '상품번호',
      // width: 80,
      dataIndex: 'productId',
      key: 'productId',
      ellipsis: true,
    },
    {
      title: '상품명',
      // width: 200,
      dataIndex: 'productName',
      key: 'productName',
      ellipsis: true,
    },
    {
      title: '옵션명',
      // width: 200,
      dataIndex: 'optionTitle',
      key: 'optionTitle',
      ellipsis: true,
    },
    {
      title: '수량',
      // width: 60,
      dataIndex: 'quantity',
      key: 'quantity',
      ellipsis: true,
    },
    {
      title: '상품별 총 주문금액',
      // width: 150,
      dataIndex: 'totalPrice',
      key: 'totalPrice',
      ellipsis: true,
      render: (value) => {
        return value.toLocaleString()
      },
    },
    {
      title: '주문상태',
      width: 90,
      dataIndex: 'orderDetailStatus',
      key: 'orderDetailStatus',
      ellipsis: true,
      render: (value, record) => {
        if (
          Object.prototype.hasOwnProperty.call(record, 'isDeposit') &&
          record.isDeposit &&
          value === 'ready'
        ) {
          return '무통장 입금대기'
        } else {
          return statusUtil.orderStatusChange(value)
        }
      },
    },
    {
      title: '택배사',
      // width: 140,
      dataIndex: 'deliveryCompany',
      key: 'deliveryCompany',
      render: (value, record) => {
        if (
          record.orderDetailStatus === 'delivery_ready' ||
          record.orderDetailStatus === 'delivery_shipping'
        ) {
          if (selectedRowKey.includes(record.orderDetailId)) {
            return (
              <Select
                className={`${styles['order-delivery-company-select']}`}
                placeholder="선택"
                value={editDeliveryInfo[record.orderDetailId].deliveryCompany}
                onChange={(value, e) =>
                  setEditDeliveryInfo({
                    ...editDeliveryInfo,
                    [e.id]: {
                      ...editDeliveryInfo[e.id],
                      deliveryCompany: value,
                    },
                  })
                }
              >
                {deliveryCompanyList.map((deliveryCompany, idx) => (
                  <Select.Option
                    key={`delivery_company_select_${idx}`}
                    id={record.orderDetailId}
                    value={deliveryCompany.deliveryCompanyId}
                  >
                    {deliveryCompany.deliveryCompanyName}
                  </Select.Option>
                ))}
              </Select>
            )
          } else {
            if (value === null || value === '') {
              return value
            } else {
              const findDeliveryCompany = deliveryCompanyList.find(
                (deliveryCompany) =>
                  deliveryCompany.deliveryCompanyId === value,
              )
              if (findDeliveryCompany) {
                return findDeliveryCompany.deliveryCompanyName
              } else {
                return value
              }
            }
          }
        } else {
          if (value === null || value === '') {
            return value
          } else {
            const findDeliveryCompany = deliveryCompanyList.find(
              (deliveryCompany) => deliveryCompany.deliveryCompanyId === value,
            )
            if (findDeliveryCompany) {
              return findDeliveryCompany.deliveryCompanyName
            } else {
              return value
            }
          }
        }
      },
    },
    {
      title: '송장번호',
      // width: 150,
      dataIndex: 'trackingNumber',
      key: 'trackingNumber',
      render: (value, record) => {
        if (
          record.orderDetailStatus === 'delivery_ready' ||
          record.orderDetailStatus === 'delivery_shipping'
        ) {
          if (selectedRowKey.includes(record.orderDetailId)) {
            return (
              <Input
                className={`${styles['order-tracking-number-input']}`}
                name={record.orderDetailId}
                value={editDeliveryInfo[record.orderDetailId].trackingNumber}
                onChange={(e) =>
                  setEditDeliveryInfo({
                    ...editDeliveryInfo,
                    [e.target.name]: {
                      ...editDeliveryInfo[e.target.name],
                      trackingNumber: e.target.value,
                    },
                  })
                }
              />
            )
          } else {
            return value
          }
        } else {
          return value
        }
      },
    },
    {
      title: '발송처리일',
      width: 100,
      dataIndex: 'shipDate',
      key: 'shipDate',
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value, record) => {
        if (
          record.orderDetailStatus === 'delivery_ready' ||
          record.orderDetailStatus === 'delivery_shipping'
        ) {
          if (selectedRowKey.includes(record.orderDetailId)) {
            return (
              <DatePicker
                className={`${styles['order-ship-date-input']}`}
                format="YYYY-MM-DD"
                value={editDeliveryInfo[record.orderDetailId].shipDate}
                onChange={(value) =>
                  setEditDeliveryInfo({
                    ...editDeliveryInfo,
                    [record.orderDetailId]: {
                      ...editDeliveryInfo[record.orderDetailId],
                      shipDate: value,
                    },
                  })
                }
              />
            )
          } else {
            if (value === null || value === '') {
              return value
            } else {
              const date = dayjs(value).format('YYYY.MM.DD')
              return date
            }
          }
        } else {
          if (value === null || value === '') {
            return value
          } else {
            const date = dayjs(value).format('YYYY.MM.DD')
            return date
          }
        }
      },
    },
    {
      title: '배송추적',
      // width: 80,
      dataIndex: '',
      key: '',
      render: (value, record) => {
        if (
          record.orderDetailStatus === 'delivery_shipping' ||
          record.orderDetailStatus === 'delivery_complete' ||
          record.orderDetailStatus === 'complete'
        ) {
          return (
            <a
              href={`https://www.goodsflow.io/tracking/tXYtiyVnAX/${record.goodsFlowServiceId}`}
              target="_blank"
              rel="noreferrer"
            >
              배송추적
            </a>
          )
        } else {
          return ''
        }
      },
    },
    {
      title: '주소',
      // width: '40%',
      dataIndex: 'address',
      key: 'address',
      ellipsis: true,
      render: (value) => {
        return <div style={{ width: 'auto' }}>{value}</div>
      },
    },
    {
      title: '상세주소',
      // width: 80,
      dataIndex: 'addressDetail',
      key: 'addressDetail',
      ellipsis: true,
    },
    {
      title: '배송 요청사항',
      // width: 100,
      dataIndex: 'addressRequest',
      key: 'addressRequest',
      ellipsis: true,
      render: (value) => {
        if (
          value !== null &&
          value !== '' &&
          value !== '배송 시 요청사항을 선택해주세요.'
        ) {
          return value
        } else {
          return ''
        }
      },
    },
    {
      title: '수취인명',
      // width: 80,
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
    },
    {
      title: '연락처',
      // width: 80,
      dataIndex: 'phone',
      key: 'phone',
      ellipsis: true,
      render: (value) => {
        return value.replaceAll('-', '')
      },
    },
    {
      title: '구매자명',
      // width: 90,
      dataIndex: 'createdByName',
      key: 'createdByName',
      ellipsis: true,
    },
    {
      title: '결제일',
      // width: 160,
      dataIndex: 'paymentCreatedAt',
      key: 'paymentCreatedAt',
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value !== null) {
          const date = dayjs(value).format('YYYY.MM.DD. HH:mm')
          return date
        }
      },
    },
    {
      title: '처방전 상태',
      // width: 90,
      dataIndex: 'prescriptionStatus',
      key: 'prescriptionStatus',
      ellipsis: true,
      render: (status) => {
        // null이나 undefined인 경우 처리
        if (status === null || status === undefined) {
          return (
            <Tag
              color="#6D747A"
              style={{
                color: '#FFF',
                fontWeight: 'bold',
                textAlign: 'center',
                justifyContent: 'center',
                // display: 'flex',
              }}
            >
              -
            </Tag>
          )
        }

        const statusConfig = {
          SUBMITTED: { text: '처방전 제출', color: '#F59E0B' },
          PURCHASED: { text: '구매완료', color: '#117FFA' },
          ADMIN_APPROVED: { text: '관리자 승인', color: '#00A4FF' },
          ADMIN_REJECTED: { text: '관리자 반려', color: '#EB516F' },
          REJECTED: { text: '공단 반려', color: '#EB516F' },
          FINALIZED: { text: '최종 완료', color: '#00A4FF' },
        }

        const config = statusConfig[status] || {
          text: status,
          color: '#6D747A',
        }

        return (
          <Tag
            color={config.color}
            style={{ color: '#FFF', fontWeight: 'bold', textAlign: 'center' }}
          >
            {config.text}
          </Tag>
        )
      },
    },
  ]

  useEffect(() => {
    getOrderDeliveryStatus()
    getDeliveryCompanyList()
  }, [])

  // useEffect(() => {
  // 	if (searchText && searchText !== " ") {
  // 		setDateType("");
  // 		setSearchOptions({
  // 			...searchOptions,
  // 			startDate: recordDates.startDate,
  // 			endDate: recordDates.endDate,
  // 			searchStatus: searchText,
  // 		});
  // 		getUserOrderList(
  // 			"custom",
  // 			recordDates.startDate,
  // 			recordDates.endDate,
  // 			searchText
  // 		);
  // 	}
  // }, [searchText]);

  useEffect(() => {
    setOrderList(totalOrderList.slice(offset, offset + pageSize))
  }, [offset, pageSize])

  useEffect(() => {
    handleChangePagination(currentPageNumber)
  }, [pageSize])

  useEffect(() => {
    // if (searchText && searchText !== " ") {
    // 	getUserOrderList(
    // 		"custom",
    // 		recordDates.startDate,
    // 		recordDates.endDate,
    // 		searchText
    // 	);
    // } else {
    // 	getUserOrderList();
    // }
    getUserOrderList()
  }, [orderType, orderBy])

  const getDeliveryCompanyList = async () => {
    setIsLoading(true)
    try {
      const res = await orderApi.deliveryCompanyList(user.id)
      if (res.data.code === 200) {
        setDeliveryCompanyList(res.data.result)
      } else {
        alert(
          '해당 정보를 가져오는데 실패했습니다. 다시 시도해주시기 바랍니다.',
        )
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log('getDeliveryCompanyList read error', error)
    }
  }

  /**
   * 주문/배송 현황 가져오기
   */
  const getOrderDeliveryStatus = async () => {
    const res = await orderApi.salesManageStatus(null, user.id)
    if (res.data.code === 200) {
      setOrderDeliveryStatus({
        ...orderDeliveryStatus,
        // deliveryShipping: res.result.deliveryShippingCnt,
        // deliveryComplete: res.result.deliveryCompleteCnt
        deliveryShipping: res.data.result.deliveryShippingList?.length,
        deliveryComplete: res.data.result.deliveryCompleteList?.length,
      })
    }
  }

  const getUserOrderList = async (
    type = '',
    startDate,
    endDate,
    searchStatus,
  ) => {
    setIsLoading(true)
    try {
      let param
      if (type === 'initial') {
        param = {
          offset: 0,
          pageSize: 10,
          pageType: 'delivery',
          searchType: searchDateItems[0].searchType,
          startDate: dayjs()
            .subtract(7, 'days')
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          endDate: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
          searchStatus: orderStatusItems[0].value,
          searchOrderId: null,
          searchProductName: '',
          funnel: 0,
          name: '',
          phone: '',
          orderType: 'paymentCreatedAt',
          orderBy: 'desc',
          searchDetailType: '',
          searchDetail: '',
          settlementId: null,
        }
      } else if (type === 'search') {
        param = {
          offset: 0,
          pageSize: 10,
          pageType: 'delivery',
          searchType: searchOptions.searchType,
          startDate: searchOptions.startDate
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          endDate: searchOptions.endDate
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          searchStatus: searchOptions.searchStatus,
          searchOrderId: searchOptions.searchOrderId,
          searchProductName: searchOptions.searchProductName,
          funnel: searchOptions.funnel,
          name: searchOptions.name,
          phone: searchOptions.phone.includes('-')
            ? searchOptions.phone.replaceAll('-', '')
            : searchOptions.phone,
          orderType: orderType,
          orderBy: orderType,
          searchDetailType: '',
          searchDetail: '',
          settlementId: null,
        }
      } else if (type === 'custom') {
        param = {
          offset: offset,
          pageSize: pageSize,
          pageType: 'delivery',
          searchType: searchOptions.searchType,
          startDate: startDate.startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          endDate: endDate.endOf('day').format('YYYY-MM-DD HH:mm:ss'),
          searchStatus: searchStatus,
          searchOrderId: searchOptions.searchOrderId,
          searchProductName: searchOptions.searchProductName,
          funnel: searchOptions.funnel,
          name: searchOptions.name,
          phone: searchOptions.phone.includes('-')
            ? searchOptions.phone.replaceAll('-', '')
            : searchOptions.phone,
          orderType: orderType,
          orderBy: orderType,
          searchDetailType: '',
          searchDetail: '',
          settlementId: null,
        }
      } else {
        param = {
          offset: offset,
          pageSize: pageSize,
          pageType: 'delivery',
          searchType: searchOptions.searchType,
          startDate: searchOptions.startDate
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          endDate: searchOptions.endDate
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          searchStatus: searchOptions.searchStatus,
          searchOrderId: searchOptions.searchOrderId,
          searchProductName: searchOptions.searchProductName,
          funnel: searchOptions.funnel,
          name: searchOptions.name,
          phone: searchOptions.phone.includes('-')
            ? searchOptions.phone.replaceAll('-', '')
            : searchOptions.phone,
          orderType: orderType,
          orderBy: orderType,
          searchDetailType: '',
          searchDetail: '',
          settlementId: null,
        }
      }
      const res = await orderApi.searchOrderDetailList(param, user.id)
      if (res.data.code === 200) {
        // setTotalOrderList(res.data.result.userOrderDetailDTOList)
        setTotalOrderList([...res.data.result.userOrderDetailDTOList].reverse())
        if (type === 'initial' || type === 'search') {
          // setOrderList(res.data.result.userOrderDetailDTOList.slice(0, 10))
          setOrderList(
            [...res.data.result.userOrderDetailDTOList].reverse().slice(0, 10),
          )
        } else {
          // setOrderList(
          //   res.data.result.userOrderDetailDTOList.slice(
          //     offset,
          //     offset + pageSize,
          //   ),
          // )
          setOrderList(
            [...res.data.result.userOrderDetailDTOList]
              .reverse()
              .slice(offset, offset + pageSize),
          )
        }
        if (res.data.result?.length !== 0) {
          setTotalSize(res.data.result.totalCnt)
        } else {
          setTotalSize(0)
        }
      } else {
        alert(
          '해당 정보를 가져오는데 실패했습니다. 다시 시도해주시기 바랍니다.',
        )
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log('getUserOrderList read error', error)
    }
  }

  const changeOrderStatus = async (orderStatus) => {
    setIsLoading(true)
    try {
      let res
      if (orderStatus === 'delivery_shipping') {
        const result = deliveryInfoValidation()
        if (result) {
          const param = {
            userOrderDetailDTOList: Object.values(editDeliveryInfo).map(
              (deliveryInfo) => {
                if (deliveryInfo?.shipDate) {
                  return {
                    ...deliveryInfo,
                    shipDate: dayjs(deliveryInfo.shipDate).format(
                      'YYYY-MM-DD HH:mm:ss',
                    ),
                  }
                } else return deliveryInfo
              },
            ),
          }
          res = await orderApi.orderTrackingNumRegister(param, user.id)
          console.log('배송 중일 때 송장 변경', res)
        } else {
          alert('배송지 및 송장번호를 입력하지 않는 항목이 있습니다.')
          throw 'not valid'
        }
      } else {
        const orderIdSet = new Set(
          selectedRow.map((selectedRow) => selectedRow.orderId),
        )
        const editOrderList = {
          orderIdList: [...orderIdSet],
          orderDetailIdList: selectedRowKey,
          orderStatus: orderStatus,
        }
        res = await orderApi.orderStatusEdit(editOrderList, user.id) // 배송 중 아닐 때 상태 변경
      }
      // '배송 중' 일 때는 orderTrackingNumRegister API response
      // 다른 상태일 때는 orderStatusEdit API response
      // 200 : 상태 '배송 중(*재송신 위함?)' or '배송 완료' 면 kakao 메세지
      if (res.code === 200 || res.data.code === 200) {
        if (orderStatus === 'delivery_shipping') {
          const orderIdSet = new Set(
            Object.values(editDeliveryInfo).map(
              (deliveryInfo) => deliveryInfo.orderId,
            ),
          )
          const orderParam = {
            orderIdList: [...orderIdSet],
            orderDetailIdList: Object.values(editDeliveryInfo).map(
              (deliveryInfo) => deliveryInfo.orderDetailId,
            ),
            orderStatus: orderStatus,
          }
          await sendKakaoAlert(orderParam)
        } else if (orderStatus === 'delivery_complete') {
          const orderIdSet = new Set(
            selectedRow.map((selectedRow) => selectedRow.orderId),
          )
          const orderParam = {
            orderIdList: [...orderIdSet],
            orderDetailIdList: selectedRowKey,
            orderStatus: orderStatus,
          }
          await sendKakaoAlert(orderParam)
        }
        alert('해당 내용이 성공적으로 반영되었습니다.')
        setSelectedRowKey([])
        setSelectedRow([])
        getUserOrderList()
        getOrderDeliveryStatus()
        // res error 999, 405 : 굿스플로 요청 실패 msg?
      } else if (
        res.data.code === 999 ||
        res.data.code === 405 ||
        res.code === 999 ||
        res.code === 405
      ) {
        console.log('혹시 여기니??', res.data)
        alert(res.data.msg)
      } else {
        alert(
          '해당 내용을 수정하는데 실패했습니다. 관리자에게 문의하시길 바랍니다.',
        )
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log('changeOrderStatus edit error', error)
    }
  }

  const editCustomerDeliveryInfo = async () => {
    setIsLoading(true)
    try {
      const res = await orderApi.orderDeliveryInfoEdit(
        customerDeliveryInfo,
        user.id,
      )
      if (res.data.code === 200) {
        alert('해당 내용이 성공적으로 반영되었습니다.')
      } else if (res.data.code === 999) {
        alert(res.data.msg)
      } else {
        alert(
          '해당 내용을 수정하는데 실패했습니다. 관리자에게 문의하시길 바랍니다.',
        )
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log('editCustomerDeliveryInfo edit error', error)
    }
  }

  /**
   * 배송 시작 및 완료 안내 알림톡 보내기
   */
  const sendKakaoAlert = async (orderParam) => {
    try {
      const res = await pushApi.kakaoForDelivery(orderParam, user.id)
      // console.log('sendKakaoAlert res', res)
      if (res.data.code !== 200) {
        alert(
          '선택한 주문건들에 대해 카카오알림톡을 보내는데 실패하였습니다.\n관리자에게 문의해주시길 바랍니다.',
        )
      }
    } catch (error) {
      setIsLoading(false)
      console.log('sendKakaoAlert alert error', error)
    }
  }

  /**
   * 구매확정 Point 적립
   */
  const purchasePointComplete = async () => {
    setIsLoading(true)
    try {
      const orderIdSet = new Set(
        selectedRow.map((selectedRow) => selectedRow.orderId),
      )
      const param = {
        orderIdList: [...orderIdSet],
      }
      const res = await orderApi.purchasePointComplete(param, user.id)
      if (res.data.code !== 200) {
        alert(
          `선택한 "${[...orderIdSet].join(
            ',',
          )}" 주문건들의 구매 확정 포인트 지급에 실패하였습니다.\n관리자에게 문의해주시길 바랍니다.`,
        )
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log('purchasePointComplete publish error', error)
    }
  }

  /**
   * handle dateType change
   */
  const handleDateTypeChange = (e) => {
    const value = e.target.value
    setDateType(value)
    switch (value) {
      case 'today':
        setSearchOptions({
          ...searchOptions,
          startDate: dayjs().startOf('day'),
          endDate: dayjs().endOf('day'),
        })
        break
      case '1week':
        if (searchOptions.endDate === null || searchOptions.endDate === '') {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs().subtract(7, 'days').startOf('day'),
            endDate: dayjs().endOf('day'),
          })
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs(searchOptions.endDate.format('YYYY/MM/DD'))
              .subtract(7, 'days')
              .startOf('day'),
          })
        }
        break
      case '1month':
        if (searchOptions.endDate === null || searchOptions.endDate === '') {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs().subtract(1, 'months').startOf('day'),
            endDate: dayjs().endOf('day'),
          })
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs(searchOptions.endDate.format('YYYY/MM/DD'))
              .subtract(1, 'months')
              .startOf('day'),
          })
        }
        break
      case '3month':
        if (searchOptions.endDate === null || searchOptions.endDate === '') {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs().subtract(3, 'months').startOf('day'),
            endDate: dayjs().endOf('day'),
          })
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs(searchOptions.endDate.format('YYYY/MM/DD'))
              .subtract(3, 'months')
              .startOf('day'),
          })
        }
        break
      case '6month':
        if (searchOptions.endDate === null || searchOptions.endDate === '') {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs().subtract(6, 'months').startOf('day'),
            endDate: dayjs().endOf('day'),
          })
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs(searchOptions.endDate.format('YYYY/MM/DD'))
              .subtract(6, 'months')
              .startOf('day'),
          })
        }
        break
    }
  }

  /**
   * 검색
   */
  const handleSearch = () => {
    if (searchOptions.startDate === null || searchOptions.endDate === null) {
      alert('조회하려는 기간이 없습니다. 다시 설정해주시길 바랍니다.')
    } else {
      if (!searchOptions.startDate.isBefore(searchOptions.endDate)) {
        alert(
          '조회하려는 기간이 잘못 설정되어있습니다. 다시 시도해주시길 바랍니다.',
        )
      } else {
        setOffset(0)
        setCurrentPageNumber(1)
        // setIsSearchText("");
        // setDates({
        // 	startDate: dayjs().format("YYYY-MM-DD"),
        // 	endDate: dayjs().add(1, "d").format("YYYY-MM-DD"),
        // });
        getUserOrderList('search')
      }
    }
  }

  /**
   * 초기화
   */
  const handleInitialBtnClick = () => {
    setSearchOptions({
      searchType: searchDateItems[0].searchType,
      searchStatus: orderStatusItems[0].value,
      searchOrderId: '',
      searchProductName: '',
      funnel: 0,
      name: '',
      phone: '',
      startDate: dayjs().subtract(7, 'days').startOf('day'),
      endDate: dayjs().endOf('day'),
    })
    setDateType(dateTypeItems[1].value)
    setOffset(0)
    setPageSize(10)
    setCurrentPageNumber(1)
    setSelectedRowKey([])
    setSelectedRow([])
    // setIsSearchText("");
    // setDates({
    // 	startDate: dayjs().format("YYYY-MM-DD"),
    // 	endDate: dayjs().add(1, "d").format("YYYY-MM-DD"),
    // });
    getUserOrderList('initial')
  }

  const tableOnChange = (pagination, filters, sorter) => {
    if (sorter) {
      //sorting 이벤트가 이루어졌을때
      if (sorter.order) {
        if (sorter.order === 'descend') {
          setOrderBy('desc')
        } else if (sorter.order === 'ascend') {
          setOrderBy('asc')
        }
        setOrderType(sorter.field)
        //sorting 이벤트 데이터가 초기화 되었을 시 (order 값 초기화)
      } else {
        setOrderType('paymentCreatedAt')
        setOrderBy('desc')
      }
    }
  }

  /**
   * page 넘김
   */
  const handleChangePagination = (pageNumber) => {
    const currOffset = (pageNumber - 1) * pageSize
    setCurrentPageNumber(pageNumber)
    setOffset(currOffset)
  }

  /**
   * pageSize 변경 handler
   */
  const pageSizeChange = (current, pageSize) => {
    setPageSize(pageSize)
    setOffset((current - 1) * pageSize)
  }

  const handleDeliveryInfoChange = (e) => {
    const { name, value } = e.target
    setCustomerDeliveryInfo({ ...customerDeliveryInfo, [name]: value })
  }

  const customerDeliveryInfoSetting = () => {
    if (selectedRow[0].orderDetailStatus === 'delivery_ready') {
      setCustomerDeliveryInfo({
        id: selectedRow[0].orderId,
        name: selectedRow[0].name,
        address: selectedRow[0].address,
        addressDetail: selectedRow[0].addressDetail,
        phone: selectedRow[0].phone,
        postalCode: selectedRow[0].postalCode,
      })
      setIsModalOpen(true)
    } else {
      alert(
        '배송지 정보 수정은 발송처리 이전까지만 가능합니다.\n선택하신 주문 건은 발송처리가 진행되어 배송지 수정이 불가능합니다.',
      )
    }
  }

  /**
   * excel download
   */
  const handleExcelDownloadClick = () => {
    try {
      let excelData
      if (selectedRow?.length !== 0) {
        excelData = selectedRow.map((row) => {
          return {
            orderId: `SG${row.orderId}`,
            orderDetailId: `sg${row.orderDetailId}`,
            paymentCreatedAt: dayjs(row.paymentCreatedAt).format(
              'YYYY.MM.DD HH:mm',
            ),
            orderDetailStatus:
              statusUtil.matchingOrderStatus[row.orderDetailStatus],
            // productId: row.productId,
            productId: `SUG-${row.productId}`,
            productName: row.productName,
            // optionId: row.optionId,
            optionId: `sgot-${row.optionId}`,
            optionTitle: row.optionTitle,
            quantity: row.quantity,
            totalPrice: row.totalPrice,
            price: row.price,
            couponDiscountPrice: row.couponDiscountPrice,
            createdByName: row.createdByName,
            usePoint: row.usePoint ? 'Y' : 'N',
            name: row.name,
            phone: row.phone,
            address: row.address
              ? row.address +
                (row.addressDetail ? `, ${row.addressDetail}` : '')
              : '',
            addressRequest:
              row.addressRequest === '배송 시 요청사항을 선택해주세요.'
                ? ''
                : row.addressRequest,
            deliveryCompany: statusUtil.matchingDeliveryCompany[
              row.deliveryCompany
            ]
              ? statusUtil.matchingDeliveryCompany[row.deliveryCompany]
              : row.deliveryCompany,
            trackingNumber: row.trackingNumber,
            shipDate: row.shipDate
              ? dayjs(row.shipDate).format('YYYY.MM.DD')
              : row.shipDate,
          }
        })
      } else if (totalOrderList?.length !== 0) {
        excelData = totalOrderList.map((row) => {
          return {
            orderId: `SG${row.orderId}`,
            orderDetailId: `sg${row.orderDetailId}`,
            paymentCreatedAt: dayjs(row.paymentCreatedAt).format(
              'YYYY.MM.DD HH:mm',
            ),
            orderDetailStatus:
              statusUtil.matchingOrderStatus[row.orderDetailStatus],
            // productId: row.productId,
            productId: `SUG-${row.productId}`,
            productName: row.productName,
            // optionId: row.optionId,
            optionId: `sgot-${row.optionId}`,
            optionTitle: row.optionTitle,
            quantity: row.quantity,
            totalPrice: row.totalPrice,
            price: row.price,
            couponDiscountPrice: row.couponDiscountPrice,
            createdByName: row.createdByName,
            usePoint: row.usePoint ? 'Y' : 'N',
            name: row.name,
            phone: row.phone,
            address: row.address
              ? row.address +
                (row.addressDetail ? `, ${row.addressDetail}` : '')
              : '',
            addressRequest:
              row.addressRequest === '배송 시 요청사항을 선택해주세요.'
                ? ''
                : row.addressRequest,
            deliveryCompany: statusUtil.matchingDeliveryCompany[
              row.deliveryCompany
            ]
              ? statusUtil.matchingDeliveryCompany[row.deliveryCompany]
              : row.deliveryCompany,
            trackingNumber: row.trackingNumber,
            shipDate: row.shipDate
              ? dayjs(row.shipDate).format('YYYY.MM.DD')
              : row.shipDate,
          }
        })
      } else {
        alert(
          '다운받으려는 데이터가 없습니다. 조회 후 다시 시도해주시길 바랍니다.',
        )
        throw 'no data'
      }
      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet(excelData)
      Object.keys(excelData[0]).forEach((key, idx) => {
        const cellAdd = XLSX.utils.encode_cell({ c: idx, r: 0 })
        ws[cellAdd].v = statusUtil.matchingKey[key]
      })
      XLSX.utils.book_append_sheet(wb, ws, '배송현황관리')
      XLSX.writeFile(wb, `${dayjs().format('YYYYMMDD')}_배송현황관리.xlsx`)
    } catch (error) {
      setIsLoading(false)
      console.log('handleExcelDownloadClick edit error', error)
    }
  }

  /**
   * 구매확정 처리 함수
   */
  const handleChangeComplete = async () => {
    const validResult = selectedRow.map((row) => {
      if (
        row.deliveryCompany === null ||
        row.deliveryCompany === '' ||
        row.trackingNumber === null ||
        row.trackingNumber === '' ||
        row.shipDate === null ||
        row.shipDate === '' ||
        row.orderDetailStatus !== 'delivery_complete'
      ) {
        return false
      } else {
        return true
      }
    })
    if (validResult.every((valid) => valid)) {
      await changeOrderStatus('complete')
      purchasePointComplete()
    } else {
      if (
        window.confirm(
          "선택한 항목들 중에 주문상태가 '배송완료'인 상태가 아니거나\n송장번호가 없는 항목들이 있습니다.\n그래도 선택하신 항목들을 구매확정 처리하시겠습니까?",
        )
      ) {
        await changeOrderStatus('complete')
        purchasePointComplete()
      }
    }
  }

  /**
   * 고객 배송지 정보수정 Modal click OK handler
   */
  const handleOk = async () => {
    if (
      customerDeliveryInfo.name === null ||
      customerDeliveryInfo.name === '' ||
      customerDeliveryInfo.address === null ||
      customerDeliveryInfo.address === ''
    ) {
      alert(
        '정보 수정하는데 필요한 값들이 채워지지 않았습니다. 다시 시도해주시길 바랍니다.',
      )
    } else {
      await editCustomerDeliveryInfo()
      setCustomerDeliveryInfo({})
      setSelectedRowKey([])
      setSelectedRow([])
      setIsModalOpen(false)
      getUserOrderList()
    }
  }

  /**
   * 고객 배송지 정보수정 Modal click cancel handler
   */
  const handleCancel = () => {
    setCustomerDeliveryInfo({})
    setIsModalOpen(false)
  }

  /**
   * 송장엑셀업로드 Modal click cancel handler
   */
  const handleExcelUploadCancel = () => {
    setUploadExcelDataHeader([])
    setUploadExcelData([])
    setIsDeliveryShippingModalOpen(false)
    setValidation(false)
  }

  /**
   * 업로드된 송장 엑셀 유효성 체크
   */
  const handleExcelValidation = async () => {
    setIsLoading(true)
    try {
      if (uploadExcelData?.length > 1) {
        let nonExistentRowList = []
        let orderIdList = []
        let duplicateOrderIdList = []
        const dataKeys = uploadExcelData.shift()
        setUploadExcelDataHeader(dataKeys)
        for (const data of uploadExcelData) {
          let validValueList = []
          Object.keys(dataKeys).forEach((key) => {
            switch (key) {
              case '개별상품주문번호':
                if (Object.prototype.hasOwnProperty.call(data, key)) {
                  if (orderIdList.includes(data[key])) {
                    duplicateOrderIdList.push(data[key])
                    validValueList.push(true)
                  } else {
                    orderIdList.push(data[key].replace('sg', ''))
                    validValueList.push(true)
                  }
                } else {
                  validValueList.push(false)
                }
                break
              case '택배사':
                if (Object.prototype.hasOwnProperty.call(data, key)) {
                  if (
                    Object.values(statusUtil.matchingDeliveryCompany).includes(
                      data[key],
                    )
                  ) {
                    validValueList.push(true)
                  } else {
                    validValueList.push(false)
                  }
                } else {
                  validValueList.push(false)
                }
                break
              case '발송일':
                if (Object.prototype.hasOwnProperty.call(data, key)) {
                  if (typeof data[key] !== 'string') {
                    validValueList.push(false)
                  } else {
                    if (/\d{4}-\d{2}-\d{2}/.test(data[key])) {
                      validValueList.push(true)
                    } else {
                      validValueList.push(false)
                    }
                  }
                }
                break
            }
          })
          if (
            !Object.prototype.hasOwnProperty.call(data, '택배사') ||
            !Object.prototype.hasOwnProperty.call(data, '송장번호')
          ) {
            nonExistentRowList.push(data.__rowNum__ + 1)
          } else {
            if (!validValueList.every((result) => result)) {
              nonExistentRowList.push(data.__rowNum__ + 1)
            }
          }
        }
        if (nonExistentRowList?.length !== 0) {
          throw `${nonExistentRowList.join(
            '행, ',
          )}행의 값이 비어있거나 올바른 형식이 아닙니다.\n올바른 파일을 다시 업로드해주세요`
        } else if (duplicateOrderIdList?.length !== 0) {
          throw `개별주문번호가 ${duplicateOrderIdList.join(
            ', ',
          )}인 행이 중복되어있습니다.\n확인 후 올바른 파일을 다시 업로드해주세요`
        } else {
          const res = await orderApi.isPossibleUploadTrackingNumber(
            {
              orderDetailIdList: orderIdList,
            },
            user.id,
          )
          if (res.data.code === 200) {
            if (res.data.result === 0) {
              setIsLoading(false)
              alert('엑셀 유효성검사가 완료되었습니다.')
              setValidation(true)
            } else {
              throw '주문항목들 중 주문상태가 배송준비중이거나 배송중이 아닌 항목들이 존재합니다.\n확인 후 올바른 파일을 다시 업로드해주세요'
            }
          } else {
            throw '해당 주문건들에 대한 주문 상태를 확인하는데 실패하였습니다.\n새로고침 후 다시 업로드 진행해주시길 바랍니다.'
          }
        }
      } else {
        throw '업로드할 데이터가 없습니다.\n데이터를 입력하거나 템플릿 수정 후 다시 업로드해주세요'
      }
    } catch (e) {
      setIsLoading(false)
      console.log('handleExcelValidation validation error', e)
      alert(e)
      setTimeout(() => {
        handleExcelUploadCancel()
      }, 1000)
    } finally {
      setIsLoading(false)
    }
  }

  /**
   * 송장 엑셀 데이터 formatting
   * + 상품주문번호에 DY 지우기 (2023.12.11) - ksb
   * 상품 주문번호 SU 지우기 (2025.03.31) - chm
   */
  const handleExcelUpload = async () => {
    setIsLoading(true)
    const dataFormatting = uploadExcelData.map((excelData) => {
      let returnValue = {}
      Object.keys(uploadExcelDataHeader).forEach((key) => {
        if (key === '택배사') {
          returnValue[uploadExcelDataHeader[key]] = Object.keys(
            statusUtil.matchingDeliveryCompany,
          ).find(
            (companyKey) =>
              statusUtil.matchingDeliveryCompany[companyKey] === excelData[key],
          )
        } else if (key === '발송일') {
          if (excelData[key]) {
            returnValue[uploadExcelDataHeader[key]] = dayjs(
              excelData[key],
            ).isValid()
              ? dayjs(excelData[key]).format('YYYY-MM-DD HH:mm:ss')
              : dayjs().format('YYYY-MM-DD HH:mm:ss')
          } else {
            returnValue[uploadExcelDataHeader[key]] = dayjs().format(
              'YYYY-MM-DD HH:mm:ss',
            )
          }
        } else if (key === '개별상품주문번호') {
          returnValue[uploadExcelDataHeader[key]] = excelData[key].replace(
            'sg',
            '',
          )
        } else if (key === '수취인명') {
          /* empty */
        } else if (key === '상품주문번호') {
          returnValue[uploadExcelDataHeader[key]] = excelData[key].replace(
            'SG',
            '',
          )
        } else {
          returnValue[uploadExcelDataHeader[key]] = excelData[key]
        }
      })
      returnValue['orderDetailStatus'] = 'delivery_shipping'
      return returnValue
    })
    try {
      const res = await orderApi.orderTrackingNumRegister(
        {
          userOrderDetailDTOList: dataFormatting,
        },
        user.id,
      )
      if (res.data.code === 200 && res.data.result) {
        const orderIdSet = new Set(
          res.data.result.map((deliveryInfo) => deliveryInfo.orderId),
        )
        const orderParam = {
          orderIdList: [...orderIdSet],
          orderDetailIdList: dataFormatting.map((deliveryInfo) =>
            deliveryInfo.orderDetailId.replace('sg', ''),
          ),
          orderStatus: 'delivery_shipping',
        }
        await sendKakaoAlert(orderParam)
        alert('해당 내용이 성공적으로 반영되었습니다.')
        getUserOrderList()
        setTimeout(() => {
          handleExcelUploadCancel()
        }, 1000)
      } else if (res.code === 999 || res.code === 405) {
        alert(res.data.msg)
      } else {
        alert(
          '해당 내용을 수정하는데 실패했습니다. 관리자에게 문의하시길 바랍니다.',
        )
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log('handleExcelUpload edit error', error)
    }
  }

  /**
   * Post Code 입력하기 (다음 주소 api)
   * @param data
   */
  const handlePostCode = (data) => {
    let fullAddress = data.address
    let extraAddress = ''

    if (data.addressType === 'R') {
      if (data.bname !== '') {
        extraAddress += data.bname
      }
      if (data.buildingName !== '') {
        extraAddress +=
          extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName
      }
      fullAddress += extraAddress !== '' ? ` (${extraAddress})` : ''
    }

    if (fullAddress?.length > 0) {
      setCustomerDeliveryInfo({
        ...customerDeliveryInfo,
        postalCode: data.zonecode,
        address: fullAddress,
      })
    }
    setIsPostalCodeModalOpen(false) // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'
  }

  /**
   * 엑셀 일괄 발송처리 > 업로드된 엑셀 읽기
   */
  const readExcelData = (e) => {
    if (e.target.value !== '') {
      let reader = new FileReader()
      reader.onload = () => {
        let fileData = reader.result
        let wb = XLSX.read(fileData, {
          type: 'binary',
          cellDates: true,
          dateNF: 'YYYY-MM-DD',
        })
        let sheetNameList = wb.SheetNames
        let firstSheet = wb.Sheets[sheetNameList[0]]

        let data = XLSX.utils.sheet_to_json(firstSheet, { raw: false })
        setUploadExcelData(data)
      }
      reader.readAsBinaryString(e.target.files[0])
    } else {
      setUploadExcelData([])
    }
  }

  const deliveryInfoValidation = () => {
    const validResult = Object.values(editDeliveryInfo).map((deliveryInfo) => {
      if (
        deliveryInfo.deliveryCompany === null ||
        deliveryInfo.deliveryCompany === '' ||
        deliveryInfo.trackingNumber === null ||
        deliveryInfo.trackingNumber === '' ||
        deliveryInfo.shipDate === null ||
        deliveryInfo.shipDate === ''
      ) {
        return false
      } else {
        return true
      }
    })
    return validResult.every((valid) => valid)
  }

  /**
   * 주문 상세 Modal cancel handler
   */
  const handleOrderDetailModalCancel = () => {
    setIsOrderModalOpen(false)
    setOrderDetail({})
  }

  const disabledDeliveryShipping = () => {
    if (selectedRow?.length === 0) {
      return true
    } else {
      return !selectedRow.every(
        (row) =>
          row.orderDetailStatus === 'delivery_ready' ||
          row.orderDetailStatus === 'delivery_shipping',
      )
    }
  }

  const disabledDeliveryComplete = () => {
    if (selectedRow?.length === 0) {
      return true
    } else {
      return !selectedRow.every(
        (row) => row.orderDetailStatus === 'delivery_shipping',
      )
    }
  }

  const disabledComplete = () => {
    if (selectedRow?.length === 0) {
      return true
    } else {
      return !selectedRow.every((row) => row.orderDetailStatus !== 'complete')
    }
  }

  const disabledValidationBtn = () => {
    if (uploadExcelData?.length !== 0 && !validation) {
      return false
    } else {
      return true
    }
  }

  return (
    <>
      <ContentHeader title="배송현황관리" />
      <div
        className={`${styles['product-register-wrap']}`}
        style={{
          minWidth: '1024px', // TODO: 사이즈 고려 중
        }}
      >
        {/*배송현황상태*/}
        <Row className={`${styles['product-search-product-status-wrap']}`}>
          {/*배송중*/}
          <Col span={12} md={5}>
            <Row className={`${styles['product-status-box-wrap']}`}>
              <img
                className={`${styles['product-status-icon']}`}
                src={`${process.env.REACT_APP_HOST}/assets/icon/sales/delivery_shipping_icon.png`}
              />
              <div className={`${styles['product-status-text']}`}>
                <div>배송중</div>
                <div>
                  <span className={`${styles['product-status-num']}`}>
                    {orderDeliveryStatus.deliveryShipping}
                  </span>{' '}
                  건
                </div>
              </div>
            </Row>
          </Col>

          {/*배송완료*/}
          <Col span={12} md={5}>
            <Row className={`${styles['product-status-box-wrap']}`}>
              <img
                className={`${styles['product-status-icon']}`}
                src={`${process.env.REACT_APP_HOST}/assets/icon/sales/delivery_complete_icon.png`}
              />
              <div className={`${styles['product-status-text']}`}>
                <div>배송완료</div>
                <div>
                  <span className={`${styles['product-status-num']}`}>
                    {orderDeliveryStatus.deliveryComplete}
                  </span>{' '}
                  건
                </div>
              </div>
            </Row>
          </Col>
        </Row>

        {/*배송현황검색*/}
        <div className={`${styles['product-search-box-wrap']}`}>
          <Form.Item
            label="조회기간"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Select
              value={searchOptions.searchType}
              onChange={(value) =>
                setSearchOptions({ ...searchOptions, searchType: value })
              }
              style={{ width: 120, textAlign: 'left' }}
            >
              {searchDateItems.map((item, idx) => (
                <Select.Option
                  key={`order_date_search_${idx}`}
                  value={item.searchType}
                >
                  {item.searchText}
                </Select.Option>
              ))}
            </Select>
            <ConfigProvider theme={CustomDateButtonRadioTheme}>
              <Row align={'middle'} style={{ marginTop: 10, gap: '5px' }}>
                <Radio.Group
                  className={`${styles['options-list']}`}
                  options={dateTypeItems}
                  onChange={handleDateTypeChange}
                  value={dateType}
                  optionType="button"
                />
                <DatePicker
                  className={`${styles['order-search-date-wrap']}`}
                  format="YYYY/MM/DD"
                  value={searchOptions.startDate}
                  onChange={(value) => {
                    setDateType('')
                    setSearchOptions({ ...searchOptions, startDate: value })
                  }}
                />
                ~
                <DatePicker
                  className={`${styles['order-search-date-wrap']}`}
                  format="YYYY/MM/DD"
                  value={searchOptions.endDate}
                  onChange={(value) => {
                    setDateType('')
                    setSearchOptions({ ...searchOptions, endDate: value })
                  }}
                />
              </Row>
            </ConfigProvider>
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']}`}
          />
          <Form.Item
            className={`${styles['center-label']}`}
            label="주문상태"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Select
              value={searchOptions.searchStatus}
              onChange={(value) =>
                setSearchOptions({ ...searchOptions, searchStatus: value })
              }
              style={{ width: 250, textAlign: 'left' }}
            >
              {orderStatusItems.map((item, idx) => (
                <Select.Option
                  key={`order_status_search_${idx}`}
                  value={item.value}
                >
                  {item.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']}`}
          />
          <Form.Item
            className={`${styles['center-label']}`}
            label="유입경로"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Radio.Group
              options={funnelStatusItems}
              onChange={(e) =>
                setSearchOptions({ ...searchOptions, funnel: e.target.value })
              }
              value={searchOptions.funnel}
            />
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']}`}
          />
          <Form.Item
            label="상세검색"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row align="middle">
              <Col sm={5} md={2}>
                <div className={`${styles['content-search-wrap']}`}>
                  주문번호
                </div>
              </Col>
              <Col style={{ marginRight: '2rem' }}>
                <Input
                  name="searchOrderId"
                  value={searchOptions.searchOrderId}
                  onChange={(e) => {
                    if (
                      numberReg.test(e.target.value) ||
                      e.target.value === ''
                    ) {
                      setSearchOptions({
                        ...searchOptions,
                        [e.target.name]: e.target.value,
                      })
                    }
                  }}
                  style={{ width: 150, textAlign: 'left' }}
                  onPressEnter={handleSearch}
                />
              </Col>
              <Col sm={5} md={2}>
                <div className={`${styles['content-search-wrap']}`}>상품명</div>
              </Col>
              <Col style={{ marginRight: '2rem' }}>
                <Input
                  name="searchProductName"
                  value={searchOptions.searchProductName}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: 'left' }}
                  onPressEnter={handleSearch}
                />
              </Col>
            </Row>
            <Row align="middle" style={{ marginTop: 10 }}>
              <Col sm={5} md={2}>
                <div className={`${styles['content-search-wrap']}`}>이름</div>
              </Col>
              <Col style={{ marginRight: '2rem' }}>
                <Input
                  name="name"
                  value={searchOptions.name}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: 'left' }}
                  onPressEnter={handleSearch}
                />
              </Col>
              <Col sm={5} md={2}>
                <div className={`${styles['content-search-wrap']}`}>연락처</div>
              </Col>
              <Col>
                <Input
                  name="phone"
                  value={searchOptions.phone}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: 'left' }}
                  onPressEnter={handleSearch}
                />
              </Col>
            </Row>
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']}`}
          />
          <Row
            className={`${styles['product-search-button-wrap']}`}
            justify="center"
          >
            <Button
              className={`${styles['product-search-button']} ${styles.search}`}
              onClick={handleSearch}
            >
              검색
            </Button>
            <Button
              className={`${styles['product-search-button']} ${styles.initial}`}
              onClick={handleInitialBtnClick}
            >
              초기화
            </Button>
          </Row>
        </div>

        {/*주문목록*/}
        <Row
          className={`${styles['product-register-border-box']}`}
          justify={'space-between'}
          wrap={false}
          style={{ marginTop: 20, borderBottom: 0 }}
        >
          <div>
            <span className={`${styles['product-register-box-title']}`}>
              주문목록 (총{' '}
              <span
                className={`${styles['product-register-box-subtitle']}`}
                style={{ marginLeft: 0 }}
              >
                {totalSize}
              </span>
              개)
            </span>
            <span className={`${styles['product-list-subtitle']}`}>
              {orderPair[orderType]}
            </span>
          </div>
          <div>
            <Button
              className={`${styles['order-excel-download-btn']}`}
              icon={
                <img
                  style={{ height: 14.2, width: 14.5, marginRight: 5 }}
                  src={`${process.env.REACT_APP_HOST}/assets/icon/common/microsoftexcel.png`}
                />
              }
              onClick={handleExcelDownloadClick}
            >
              엑셀다운
            </Button>
          </div>
        </Row>
        <Row
          className={`${styles['product-register-border-box']}`}
          justify={'space-between'}
          wrap={false}
        >
          <Row align={'middle'} style={{ gap: 10 }}>
            <Button
              className={`${styles['order-status-change-button']}`}
              disabled={disabledDeliveryShipping()}
              onClick={() => changeOrderStatus('delivery_shipping')}
            >
              발송처리
            </Button>
            <Button
              className={`${styles['order-status-change-button']}`}
              onClick={() => setIsDeliveryShippingModalOpen(true)}
            >
              엑셀 일괄 발송처리
            </Button>
            <Button
              className={`${styles['order-status-change-button']}`}
              disabled={disabledDeliveryComplete()}
              onClick={() => changeOrderStatus('delivery_complete')}
            >
              배송완료 처리
            </Button>
            <Button
              className={`${styles['order-status-change-button']}`}
              disabled={disabledComplete()}
              onClick={handleChangeComplete}
            >
              구매확정 처리
            </Button>
          </Row>
          {/* <div>
            <Button
              className={`${styles['order-status-change-button']}`}
              onClick={() => navigate('/order/complete')}
            >
              구매확정 후 취소처리 바로가기
              <img
                style={{ height: 14.2, width: 14.5 }}
                src={`${process.env.REACT_APP_HOST}/assets/icon/sales/right-arrow-gray.png`}
              />
            </Button>
          </div> */}
        </Row>
        <div
          className={`${styles['product-register-border-box']}`}
          style={{
            borderTop: 0,
            borderBottom: 0,
            padding: '20px 25px 40px',
            height: 'fit-content',
          }}
        >
          <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={orderList}
            loading={isLoading}
            bordered
            size="middle"
            rowKey="orderDetailId"
            rowClassName="coupon-table-row"
            scroll={{ x: 'max-content' }}
            tableLayout={'auto'}
            onChange={tableOnChange}
            pagination={false}
          />

          <Pagination
            showSizeChanger
            pageSize={pageSize}
            onShowSizeChange={pageSizeChange}
            total={totalSize}
            current={currentPageNumber}
            onChange={handleChangePagination}
            align={'end'}
            style={{ marginTop: 20 }}
          />
        </div>
        <div
          className={`${styles['product-register-border-box']}`}
          style={{
            backgroundColor: '#f8f9fd',
            height: 'fit-content',
            padding: '15px 25px',
          }}
        >
          <Form.Item
            className={`${styles['order-bottom-form-item']} ${styles['center-label']}`}
            label="배송현황 관리"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row align={'middle'} style={{ gap: 10 }}>
              <Button
                className={`${styles['order-status-change-button']}`}
                onClick={() => setIsDeliveryShippingModalOpen(true)}
              >
                엑셀 일괄 발송처리
              </Button>
              <Button
                className={`${styles['order-status-change-button']}`}
                disabled={disabledDeliveryComplete()}
                onClick={() => changeOrderStatus('delivery_complete')}
              >
                배송완료 처리
              </Button>
            </Row>
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']} ${styles['order-bottom-divider-margin']}`}
          />
          <Form.Item
            className={`${styles['order-bottom-form-item']} ${styles['center-label']}`}
            label="구매확정 관리"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row>
              <Button
                className={`${styles['order-status-change-button']}`}
                disabled={disabledComplete()}
                onClick={handleChangeComplete}
              >
                구매확정 처리
              </Button>
            </Row>
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']} ${styles['order-bottom-divider-margin']}`}
          />
          <Form.Item
            className={`${styles['order-bottom-form-item']} ${styles['center-label']}`}
            label="정보수정"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row align={'middle'} style={{ gap: 10 }}>
              <Button
                className={`${styles['order-status-change-button']}`}
                disabled={disabledDeliveryShipping()}
                onClick={() => changeOrderStatus('delivery_shipping')}
              >
                발송처리
              </Button>
              <Button
                className={`${styles['order-status-change-button']}`}
                disabled={
                  selectedRowKey?.length !== 1 ||
                  selectedRow[0]?.orderDetailStatus !== 'delivery_ready'
                }
                onClick={customerDeliveryInfoSetting}
              >
                고객 배송지 정보수정
              </Button>
            </Row>
          </Form.Item>
        </div>

        {/*고객배송지정보수정Modal*/}
        {selectedRow?.length !== 0 &&
        Object.keys(customerDeliveryInfo)?.length !== 0 ? (
          <Modal
            title="고객 배송지 정보수정"
            open={isModalOpen}
            centered={true}
            cancelText={<span>취소</span>}
            okText={<span>정보 수정</span>}
            onOk={handleOk}
            onCancel={handleCancel}
            // width={"80%"}
            style={{ padding: 20 }}
          >
            <Form.Item
              label="수령자명"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              required
            >
              <Input
                name="name"
                value={customerDeliveryInfo.name}
                onChange={handleDeliveryInfoChange}
              />
            </Form.Item>
            <Form.Item
              label="연락처"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
            >
              <Input
                name="phone"
                value={customerDeliveryInfo.phone}
                onChange={handleDeliveryInfoChange}
              />
            </Form.Item>
            <Form.Item
              label="우편번호"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
            >
              <Row justify={'space-between'} style={{ width: '100%' }}>
                <Col span={10}>
                  <Input
                    name="postalCode"
                    value={customerDeliveryInfo.postalCode}
                    onChange={handleDeliveryInfoChange}
                  />
                </Col>
                <Col span={'auto'}>
                  <Button onClick={() => setIsPostalCodeModalOpen(true)}>
                    우편번호 검색
                  </Button>
                </Col>
              </Row>
            </Form.Item>
            <Form.Item
              label="주소"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              required
            >
              <Input
                name="address"
                value={customerDeliveryInfo.address}
                onChange={handleDeliveryInfoChange}
              />
            </Form.Item>
            <Form.Item
              label="상세주소"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
            >
              <Input
                name="addressDetail"
                value={customerDeliveryInfo.addressDetail}
                onChange={handleDeliveryInfoChange}
              />
            </Form.Item>
          </Modal>
        ) : null}

        {/*우편번호검색Modal*/}
        {isPostalCodeModalOpen && (
          <Modal
            className="order-postal-code-modal"
            open={isPostalCodeModalOpen}
            onCancel={() => setIsPostalCodeModalOpen(false)}
            footer={null}
          >
            <DaumPostcodeEmbed
              style={{
                height: '450px',
              }}
              submitMode={false}
              onComplete={handlePostCode}
            />
          </Modal>
        )}

        {/*송장 엑셀 일괄 발송처리Modal*/}
        {isDeliveryShippingModalOpen && (
          <Modal
            className="order-tracking-number-modal"
            title="엑셀 일괄 발송처리"
            open={isDeliveryShippingModalOpen}
            onCancel={handleExcelUploadCancel}
            footer={[
              <Button
                key="back"
                onClick={handleExcelUploadCancel}
                loading={isLoading}
                disabled={isLoading}
              >
                돌아가기
              </Button>,
              <Button
                type="primary"
                loading={isLoading}
                disabled={disabledValidationBtn()}
                onClick={handleExcelValidation}
              >
                유효성검사하기
              </Button>,
              <Button
                key="submit"
                type="primary"
                loading={isLoading}
                disabled={!validation}
                onClick={handleExcelUpload}
              >
                자료업로드하기
              </Button>,
            ]}
          >
            <p style={{ paddingBottom: 10 }}>
              * 업로드할 엑셀파일을 선택해주세요(.xlsx)
            </p>
            <p style={{ paddingBottom: 10 }}>
              * 일괄발송처리 전용 파일 양식을 통한 등록도 가능합니다.
            </p>
            <Button
              className="excel-template-download-btn"
              href={`${process.env.REACT_APP_HOST}/assets/files/TrackingNumber_Template.xlsx`}
            >
              일괄발송처리 양식 다운 {'>'}
            </Button>
            <input
              disabled={validation}
              type={'file'}
              id="excelFile"
              onChange={readExcelData}
            />
          </Modal>
        )}
      </div>

      {/*주문 상세 페이지*/}
      {isOrderModalOpen && (
        <Modal
          title="상품주문정보 조회"
          wrapClassName="order-detail-modal-wrap"
          open={isOrderModalOpen}
          centered={true}
          onCancel={handleOrderDetailModalCancel}
          footer={null}
          width="70%"
        >
          <OrderDetailComponent
            orderDetail={orderDetail}
            handleOrderDetailModalCancel={handleOrderDetailModalCancel}
            getUserOrderList={getUserOrderList}
          />
        </Modal>
      )}
    </>
  )
}

export default OrderDeliveryPage
